// Diego, 13-oct (ADENDA, pedido 8): en cada opción, en qué rango cotiza la competencia en Sonora para ese tamaño y esa
// tarifa (SunWise Analytics, 2026). Es una referencia para el vendedor: no cambia el precio ni va en el PDF.
import { numero, rangoCompetencia } from '@cotizador/compartido';
import type { Tarifa } from '@cotizador/compartido';

/** Menos de 1.5 % de diferencia se dice «en el promedio». */
const TOLERANCIA_PCT = 1.5;

export function textoComparacion(usdPorW: number, prom: number): string {
  const dif = (usdPorW / prom - 1) * 100;
  if (Math.abs(dif) < TOLERANCIA_PCT) return 'esta opción va en el promedio';
  return `esta opción va ${numero(Math.abs(dif), 0)} % ${dif > 0 ? 'arriba' : 'abajo'} del promedio`;
}

export function CompetenciaOpcion({ tarifa, kwp, usdPorW }: { tarifa: Tarifa; kwp: number; usdPorW: number | undefined }) {
  const c = rangoCompetencia(tarifa, kwp);
  if (!c) return null;
  const retorno = c.retorno_min === c.retorno_max ? numero(c.retorno_min, 1) : `${numero(c.retorno_min, 1)}–${numero(c.retorno_max, 1)}`;
  return (
    <p className="opcion__porw opcion__competencia" title={`SunWise Analytics, propuestas de Sonora en 2026 (medido el ${c.medido}); USD/W sin IVA.`}>
      Competencia en Sonora ({c.grupo}, {c.rango}): <strong>{numero(c.min, 2)}–{numero(c.max, 2)} USD/W</strong>, promedio {numero(c.prom, 2)} ·
      retorno {retorno} años
      {usdPorW !== undefined && <> · {textoComparacion(usdPorW, c.prom)}</>}
    </p>
  );
}
